import api from './api';
import type { Photographer } from '../../shared/types';

export const getPhotographers = async (agencySlug: string): Promise<Photographer[]> => {
  try {
    const response = await api.get(`/agencies/${agencySlug}/photographers`);
    return response.data;
  } catch (error) {
    console.error('Error fetching photographers:', error);
    throw error;
  }
};

export const createPhotographer = async (agencySlug: string, photographerData: Partial<Photographer>): Promise<Photographer> => {
  try {
    const response = await api.post(`/agencies/${agencySlug}/photographers`, photographerData);
    return response.data;
  } catch (error) {
    console.error('Error creating photographer:', error);
    throw error;
  }
};

export const updatePhotographer = async (agencySlug: string, photographerId: string, photographerData: Partial<Photographer>): Promise<Photographer> => {
  try {
    const response = await api.put(`/agencies/${agencySlug}/photographers/${photographerId}`, photographerData);
    return response.data;
  } catch (error) {
    console.error('Error updating photographer:', error);
    throw error;
  }
};

export const deletePhotographer = async (agencySlug: string, photographerId: string): Promise<void> => {
  try {
    await api.delete(`/agencies/${agencySlug}/photographers/${photographerId}`);
  } catch (error) {
    console.error('Error deleting photographer:', error);
    throw error;
  }
};

